/** Minimal inert document — keeps srcdoc iframe mounted without scripts. */
export const EMPTY_PREVIEW_SRCDOC = '<!DOCTYPE html><html><head><meta charset="utf-8"></head><body></body></html>'

export const IMAGE_KEYS = ['header', 'logo', 'watermark', 'signature']

export const IMAGE_LABELS = {
  header: 'Header',
  logo: 'Logo',
  watermark: 'Watermark',
  signature: 'Signature',
}

export const IMAGE_HINTS = {
  header: 'Sattva letterhead banner — change only if needed',
  logo: 'Sattva wordmark — change only if needed',
  watermark: 'Sattva diamond mark — change only if needed',
  signature: 'Signatory image used in the closing block',
}

export const IMAGE_ICONS = {
  header: 'LayoutIcon',
  logo: 'AwardIcon',
  watermark: 'LayersIcon',
  signature: 'Edit3Icon',
}

export const WIZARD_STEP_LABELS = [
  'Site & Role',
  'Write Letter',
  'Salary & Branding',
  'Review & Save',
]

export const BRANDING_PLACEHOLDER_LABELS = new Set([
  'Header Image',
  'Logo',
  'Watermark',
  'Signature Image',
])

export const LETTER_SECTION_CHIP_DEFS = [
  { key: 'intro', label: 'Opening' },
  { key: 'jobResponsibilities', label: 'Job Resp.' },
  { key: 'body', label: 'Policies' },
  { key: 'terms', label: 'Terms' },
  { key: 'salary', label: 'Salary' },
  { key: 'closing', label: 'Closing' },
]

export const LETTER_CONTENT_SECTION_KEYS = [
  'intro',
  'jobResponsibilities',
  'body',
  'terms',
  'closing',
]

export const LETTER_SECTION_EDITOR_DEFS = [
  {
    key: 'intro',
    field: 'intro',
    sectionKey: 'intro',
    number: 1,
    label: 'Opening',
    title: 'Opening paragraph',
    hint: 'Welcome & offer summary after the greeting',
    tooltip: 'Sets the tone — congratulations and role summary.',
    supportsTitle: false,
    breakField: 'intro',
  },
  {
    key: 'jobResponsibilities',
    field: 'jobResponsibilities',
    sectionKey: 'jobResponsibilities',
    number: 2,
    label: 'Job Responsibilities',
    title: 'Job Responsibilities',
    hint: 'Duties and expectations for the role',
    tooltip: 'Role duties and responsibilities for the offered position.',
    supportsTitle: true,
    breakField: 'jobResponsibilities',
  },
  {
    key: 'body',
    field: 'body',
    sectionKey: 'body',
    number: 3,
    label: 'Employment Policies',
    title: 'Employment Policies & Provisions',
    hint: 'Benefits, probation, leave & policies',
    tooltip: 'Benefits, probation, leave policy, etc.',
    supportsTitle: true,
    breakField: 'body',
  },
  {
    key: 'terms',
    field: 'termsAndConditions',
    sectionKey: 'terms',
    number: 4,
    label: 'Terms & Conditions',
    title: 'Terms & Conditions',
    hint: 'Legal terms and acceptance clauses',
    tooltip: 'Termination, property return, and acceptance clauses.',
    supportsTitle: true,
    breakField: 'termsAndConditions',
  },
  {
    key: 'salary',
    field: 'salaryStructure',
    sectionKey: 'salary',
    number: 5,
    label: 'Salary Annexure',
    title: 'Salary Annexure',
    hint: 'Compensation table and footnotes',
    tooltip: 'Monthly salary breakdown — configured on the Salary & Branding step.',
    supportsTitle: true,
    isSalaryStep: true,
  },
  {
    key: 'closing',
    field: 'closing',
    sectionKey: 'closing',
    number: 6,
    label: 'Closing & Signature',
    title: 'Closing & Signature',
    hint: 'Closing paragraph & company signatory',
    tooltip: 'Closing remarks and company signatory (name, designation, stamp). Employee Name / Signature are in Stamp settings.',
    supportsTitle: false,
    isClosing: true,
    breakField: 'closing',
  },
]

export const TABLE_FIELDS = [
  { key: 'client', label: 'Client', sortable: true, class: 'h6 mb-0' },
  { key: 'jobTitle', label: 'Job Title', sortable: true, class: 'h6 mb-0' },
  { key: 'location', label: 'Location', class: 'h6 mb-0' },
  { key: 'is_active', label: 'Status', class: 'text-center h6 mb-0' },
  { key: 'actions', label: '', class: 'text-right' },
]

// Client save guard (~1.9 MB) — generous for text + logo/header/watermark; align SattvaATS/server.js to 2 MB.
export const MAX_OFFER_CONFIG_PAYLOAD_BYTES = 1900 * 1024
export const MAX_OFFER_CONFIG_FIELD_LENGTH = 255
